import { useQuery } from '@tanstack/react-query'
import { apiClient } from '../services/apiService'

export const useStatuses = () => {
  return useQuery({
    queryKey: ['statuses'],
    queryFn: async (): Promise<{ data: string[] }> => {
      const response = await apiClient.get('/status-filters/statuses')
      const data = response.data
      
      if (!data.success) {
        throw new Error(data.message || 'Failed to load statuses')
      }
      
      return { data: data.data || [] }
    },
    staleTime: 10 * 60 * 1000, // 10 minutes
    refetchOnWindowFocus: false
  })
}

export const useStatusStats = () => {
  return useQuery({
    queryKey: ['status-stats'],
    queryFn: async () => {
      const response = await apiClient.get('/status-filters/stats')
      const data = response.data
      
      if (!data.success) {
        throw new Error(data.message || 'Failed to load status statistics')
      }
      
      return { data: data.data }
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchOnWindowFocus: false
  })
}
